module.exports = __webpack_public_path__ + "static/img/11.55d6d2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/sp/11.png
// module id = tDts
// module chunks = 0